import { render, staticRenderFns } from "./recharge_lottery.vue?vue&type=template&id=8bcd1904&scoped=true"
import script from "./recharge_lottery.vue?vue&type=script&lang=ts"
export * from "./recharge_lottery.vue?vue&type=script&lang=ts"
import style0 from "./recharge_lottery.vue?vue&type=style&index=0&id=8bcd1904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd1904",
  null
  
)

export default component.exports